import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

export const SeoManager = () => {
  const location = useLocation();
  useEffect(() => {
    let cancelled = false;
    const update = async () => {
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/seo/page`, { params: { path: location.pathname, preview: new URLSearchParams(location.search).has('preview_proposal') } });
        if (cancelled) return;
        document.querySelectorAll('title,meta[name="description"],meta[name="robots"],meta[name^="twitter:"],meta[property^="og:"],link[rel="canonical"],#page-structured-data').forEach(el => el.remove());
        const parsed = new DOMParser().parseFromString(`<head>${data.head}</head>`, 'text/html');
        [...parsed.head.children].forEach(node => document.head.appendChild(document.importNode(node, true)));
      } catch { /* Keep server metadata when the connection is interrupted. */ }
    };
    update();
    window.addEventListener('cms-config-updated', update);
    return () => { cancelled = true; window.removeEventListener('cms-config-updated', update); };
  }, [location.pathname, location.search]);
  return null;
};